<div class="flex-space-center">
  <h3 class="m-0">{{ title }}</h3>
  <i class="material-icons text-size-huge text-color-gold c-pointer" (click)="close()">close</i>
</div>
